import { useEffect } from 'react'
import { callIfFunction } from '@startlibs/utils'

export const ScrollToTop = ({when,onScroll}) => {
  useEffect(() => {
    window.scroll(window.pageXOffset,0)
    callIfFunction(onScroll)
  },[when])

  return null
}